export function formatGuestUserLabel(row: {
	name: string | null;
	surname: string | null;
	phone: string;
}): string {
	const name = [row.name, row.surname].filter(Boolean).join(" ").trim();
	if (name) {
		return `${name} · ${row.phone}`;
	}
	return row.phone;
}
